<template>
    <div class="contactUs">
        <div class="top">
          <img src="http://video.naolamp.com/officialWeb/contact/contact_1.jpg"/>
        </div>
      <div class="content">
          <h3>广州车灯师信息科技有限公司</h3>
          <div class="text">
              <p class="phone">联系电话：020-32885480</p>
              <p class="address">地址：广州天河区中城路300号酷车城F-120</p>
            </div>
        </div>
      <div class="bottom">
          <img src="http://video.naolamp.com/officialWeb/contact/contact_2.jpg"/>
        </div>
    </div>
</template>

<script>
import loading from '../common/loading.vue'
export default {
  name: 'contactUs',
  data () {
    return {
      msg: '联系我们',
      isLoad: true
    }
  },
  computed: {
  },
  mounted: function (s) {
    this.isLoad = false
  },
  methods: {
  },
  filters: {
  },
  components: {
    loading
  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.contactUs {
  padding-top: 52px;
  background-color: #FFFFFF;
  padding-bottom: 80px;
  border-bottom: 1px solid #e8e8e8;
}

.top img {
  width: 100%;
}

.content {
  padding: 50px;
}

.content .text {
  margin-top: 20px;
}

.content .text .phone {
  font-family: "SourceHanSansCN-Normal";
}

.content .text .address {
  margin-top: 5px;
  font-family: "SourceHanSansCN-Normal";
}

.bottom img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/about/contactUs.vue